import './PageLayout.css'

const PageLayout = ({children, height="", padding="", pageClassName=""})=>{
    let style = {}
    if(padding) style = {padding:padding};

    return (
        <div style={style} className={`container filled-container ${pageClassName}`}>
            <div style={{height:height}} className={"content"}>
                {children}
            </div>
        </div>
    )
}

export default PageLayout;